import store from 'config/store'
import { triggerPlaybookFiredAPIEvent } from 'modules/api/events'
import { assignActiveCampaignFromMessage } from 'modules/campaigns'
import { hasActiveCampaign } from 'modules/campaigns/selectors'
import { markMessageAsRead } from 'modules/conversations'
import { setActiveConversation } from 'modules/conversations/actions'
import { sendPlaybookImpression } from 'modules/impressions'
import { getMessageAttribute, hasMessageAttribute, shouldReceiveMessage } from 'modules/message/utils'
import { toggleChat } from 'modules/view/actions'
import { path, pathOr } from 'ramda'
import { Message, MessageContentType } from 'types/message'

import { evaluateChatMessage, evaluateEndUserResponseChatMessage } from './chat'
import { evaluateConditionalMessage } from './conditional'
import { evaluateLiveViewMessage } from './liveView'

export const evaluateNewMessage = (payload: { body?: { data: Message } }) => {
  const message: Message = path(['body', 'data'], payload)
  const state = store.getState()

  if (!message) {
    return
  }

  const hasWidgetGuid = hasMessageAttribute(message, 'widgetGuid')
  if (hasWidgetGuid) {
    return evaluateEndUserResponseChatMessage(message)
  }

  const isNewBotCampaignMessage = hasMessageAttribute(message, 'startInteraction')
  const isLiveViewInitiatedMessage = hasMessageAttribute(message, 'liveViewInitiated')
  const playbookId = getMessageAttribute(message, 'playbookId')
  const interactionId = getMessageAttribute(message, 'interactionId')
  const isExperiment = getMessageAttribute(message, 'isExperiment')
  const conversationId = message.conversationId
  const shouldDisplayNewPlaybook = !hasActiveCampaign(state) && isNewBotCampaignMessage

  const isConditionalSkillMessage = message.contentType === MessageContentType.BOT_NODE_CONDITION_EVALUATION && hasMessageAttribute(message, 'conditionSetsToEvaluate')
  const isReadMessage = pathOr(false, ['contentType', MessageContentType.CHAT], message) && !message.body.length

  if (shouldDisplayNewPlaybook) {
    triggerPlaybookFiredAPIEvent(message)
    assignActiveCampaignFromMessage(message)
    store.dispatch(setActiveConversation({ conversationId }))
    sendPlaybookImpression({
      playbookId,
      interactionId,
      conversationId,
      isVirtual: false,
      isExperiment
    })

    const isOpenableNewDriftlinkMessage = getMessageAttribute(message, 'goToConversation')
    if(!!isOpenableNewDriftlinkMessage) {
      store.dispatch(toggleChat({ chatOpen: true }))
    }
  }

  if (isLiveViewInitiatedMessage) { return evaluateLiveViewMessage(message) }
  if (isConditionalSkillMessage) { return evaluateConditionalMessage(message) }

  if (shouldReceiveMessage(message)) { return evaluateChatMessage(payload) }
  else if (isReadMessage) {
    markMessageAsRead(message.conversationId as number, message.id)
  }
}
